import Vue from 'vue'
import Moment from 'moment'
import App from './App.vue'

import './styles/main.scss'

import $cfg from './config/cfg'; window.$cfg = $cfg; Vue.prototype.$cfg = $cfg;
import _ from 'lodash'; window._ = _;
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false;

Vue.prototype.$formatDate = function(date) {
  return Moment(date).format('YYYY-MM-DD HH:mm')
}

window.app = new Vue({
  data: {
    sidebar: false,
  },
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
